jQuery(function ($) {
    const body = $('body');
    const top = $('#top');
    const searchForm = top.find('.search-form');
    const mobileWidth = 1024
    let currentWidth = $(window).width();
    let isMobile = true;
    let mobileMenuOpen = false;

    $('.submenu').hover(function () {
        if (isMobile) {
            return;
        }

        body.addClass('overlay')

        top.removeClass('border-white')
            .addClass('border-gray')
    }, function () {
        $(document).trigger('closeDesktopSubMenu');
    })

    var mainMenu = $('#main-menu > nav')
    $('#mobile-menu').click(function () {
        mobileMenuOpen = true;
        body.append($('<div/>',{
            id: 'menu-overlay'
        }))

        mainMenu.find('> ul').prepend(
            $('<li>')
                .addClass('menu-header')
                .append(
                    $('<a>')
                        .attr({
                            href: 'javascript:void(0);',
                            'data-close-menu': '',
                        })
                        .html('Categorie&euml;n')
                )
                .append(getCloseButton())
        )
        mainMenu.prependTo(body);

        $('#trustbadge-container-98e3dadd90eb493088abdc5597a70810').hide()
    })

    mainMenu.find('> ul > li > a').click(function (e) {
        var li = $(this).closest('li')

        if (!li.hasClass('submenu') || !isMobile) {
            return;
        }

        e.preventDefault()

        var subMenu = li.find('> div');

        $('<div>')
            .append(
                $('<a>')
                    .attr({
                        href: 'javascript:void(0);',
                        'data-back-to-parent': '',
                    })
                    .addClass('submenu-close')
                    .html($(this).data('name'))
            )
            .append(getCloseButton())
            .addClass('menu-header')
            .prependTo(subMenu);

        subMenu.css('display', 'flex')
            .addClass('slide-in');

        li.addClass('open');
    })

    $(document)
        .on('click', '[data-close-menu]', function (e) {
            $(document).trigger('closeMobileMenu');
        })
        .on('click', '[data-back-to-parent]', function (e) {
            $(document).trigger('closeMobileSubMenu');
        })
        .on('click', '#menu-overlay', function() {
            $(document).trigger('closeMobileMenu');
        })
        .on('closeMobileMenu', function () {
            $('.menu-header').remove();
            $('#menu-overlay').remove();

            $(document).trigger('closeMobileSubMenu');
            $(document).trigger('hideSearchForm');

            mainMenu.prependTo($('#main-menu'))
            mobileMenuOpen = false;
        })
        .on('closeMobileSubMenu', function () {
            $('.mega-menu').removeClass('slide-in').attr('style', '');
            $('.submenu-close').closest('.menu-header').remove();
            $('.submenu.open').removeClass('open')
            $('#trustbadge-container-98e3dadd90eb493088abdc5597a70810').show()
        })
        .on('closeDesktopSubMenu', function () {
            if (!mobileMenuOpen) {
                 body.removeClass('overlay')
            }

            top.addClass('border-white')
                .removeClass('border-gray')
        })
        .on('hideSearchForm', function () {
            searchForm.prependTo($('#main-menu').find('.header-actions'));
        })

    $(window).resize(function () {
        isMobile = $(this).width() < mobileWidth;

        // We need to check if the width has been changed to prevent unnecessary redraws
        if ($(this).width() === currentWidth) {
            return;
        }

        currentWidth = $(this).width();

        if (isMobile) {
            $(document).trigger('closeDesktopSubMenu');
        } else {
            $(document).trigger('closeMobileMenu');
        }
    }).resize();

    $('[data-toggle-search-form]').click(function(){
        if (top.find('> .search-form').length === 1) {
            $(document).trigger('hideSearchForm');

            return;
        }

        searchForm.appendTo(top)
        searchForm.find('input').focus();
    });

    function getCloseButton()
    {
        return $('<a>')
            .attr({
                'href': 'javascript:void(0);',
                'data-close-menu': '',
            })
            .addClass('close-button text-2xl')
            .html('&times;');
    }
})